// @ts-strict-ignore
import { IntegrationType } from '../../types';
import * as React from 'react';
import { iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import { AppstoreFilled } from '@ant-design/icons';
import { antGrey } from '../styles/globalStyles';

interface IntegrationIconProps {
    integrationId?: IntegrationType;
    size?: number;
    opacity?: number;
    marginTop?: number;
}

const IntegrationIcon: React.FC<IntegrationIconProps> = (props: IntegrationIconProps) => {
    const [icon, alt] = iconAndAltForIntegrationType(props.integrationId);
    if (icon) {
        return (
            <img
                src={icon}
                alt={alt}
                width={props.size ?? 18}
                height={props.size ?? 18}
                style={{ opacity: props.opacity ?? 1, marginTop: props.marginTop ?? 0 }}
            />
        );
    } else {
        return <AppstoreFilled style={{ fontSize: props.size ? props.size - 1 : 17, color: antGrey.grey6 }} />;
    }
};

export default IntegrationIcon;
